export default __webpack_public_path__ + "static/media/results5.ad10f1c9.png";